import React from "react"

const FormSubmissionViewedAuditItemDetails = () => (
  <div className="user-actions-audit-trail">
    Viewed submission.
  </div>
)

export default FormSubmissionViewedAuditItemDetails
